var map = {
	"./de/text-pc.png": "k/5k",
	"./en/text-pc.png": "zluw",
	"./es/text-pc.png": "dQhb",
	"./fr/text-pc.png": "TvL1",
	"./ja/text-pc.png": "v9sC",
	"./ko/text-pc.png": "GbRd",
	"./pt/text-pc.png": "3M82",
	"./ru/text-pc.png": "6iIt",
	"./th/text-pc.png": "fYOf",
	"./zh-Hant/text-pc.png": "aXSE"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "RLVa";